// Création de l'objet à envoyer au back
const formaterFichierVersoLicenceBallTrap = async (dataForm) => {
    return dataForm.versoLicenceBallTrap ? dataForm.versoLicenceBallTrap[0].getFileToSend() : null;
};

export default formaterFichierVersoLicenceBallTrap;
